import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-anti-sexual-harassment-grievance-cell',
  templateUrl: './anti-sexual-harassment-grievance-cell.component.html',
  styleUrls: ['./anti-sexual-harassment-grievance-cell.component.scss']
})
export class AntiSexualHarassmentGrievanceCellComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
